import styled from 'styled-components';
import { BREAKPOINTS } from "../../../../../app/appConstants";

export const ChangePaymentSubmitButtonContainerStyled = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    
    @media (max-width: ${BREAKPOINTS.medium}px) {
        position: fixed;
        padding: 16px 16px 24px;
        bottom: 0;
        left: 0;
        width: 100%;
        backdrop-filter: blur(4px);
        > button {
            flex: 1;
        }
    }
`;

export const ChangePaymentDividerStyled = styled.hr`
    background: var(--color-main);
    margin: 0 0 16px 0;
`;

export const ChangePaymentMethodRowStyled = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 1;
    
    .btn-info {
        padding: 12px;
        background: var(--color-neutral-20);
    }
`;
